module.exports = __webpack_public_path__ + "img/password-valid-icon.6d5437dd.svg";